import { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';

// locals
import { useInputChangeHandler } from 'app/hooks';
import { RegionService } from 'app/services';
import { FormInput, CustomAutoComplete, FormBasicSelect, CustomDatePicker } from '../../atoms';
import { Constants } from 'app/utils';

const FilterPharmacies = ({ handleChange, setQueries }) => {
  // states
  const { values, setFieldValue, preventNonSpecialDebounceInput, handleFilterInputChange } =
    useInputChangeHandler(handleChange);
  const [cityOptions, setCityOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);

  // variables
  const cityVal = values?.city_id?.value;
  const districtVal = values?.district_id?.value;
  const isDisabled = !cityVal;
  const showDateFilters = values?.is_pharmacy_on_duty === 'true';

  // autocomplete filter input related funcs.
  const handleFilterAutoComplete = (e, name) => {
    if (e) {
      setQueries(prevState => ({
        ...prevState,
        skip: 0,
        [name]: e.value
      }));
    } else {
      setQueries(prevState => ({
        ...prevState,
        skip: 0,
        [name]: ''
      }));
    }
  };

  // *** handle async autocomplete
  const handleAutoComplete = (name, e) => {
    name === 'city_id' && setFieldValue('district_id', null);
    setFieldValue(name, e);
    handleFilterAutoComplete(e, name);
  };

  // fetch cities
  const defaultCity = async () => {
    try {
      const data = await RegionService.getCityListWithoutPagination();
      const out = data?.data?.data.map(i => ({ label: i.name, value: i.id }));
      setCityOptions(out);
      return out;
    } catch (err) {
      console.log('error :>> ', err);
    }
  };

  useEffect(() => defaultCity(), []);

  /* Conditional customSelect value changes  */
  useEffect(() => {
    // get district options
    const handleDistrictOptions = async () => {
      if (cityVal) {
        try {
          const data = await RegionService.getDistrictListWithoutPagination(
            { filter: '' },
            cityVal
          );
          const out = data?.data?.data?.map(i => ({ label: i.name, value: i.id }));
          setDistrictOptions(out);
          return out;
        } catch (err) {
          console.log('err :>> ', err);
        }
      }
    };

    /* Set options conditionally */
    if (cityVal) {
      setDistrictOptions([]);
      !districtVal && handleDistrictOptions();
    } else {
      handleAutoComplete('district_id', null);
      setDistrictOptions([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityVal]);

  return (
    <>
      <Grid container spacing={2} className="items-center mt-8">
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <CustomAutoComplete
            id="campaign_pharmacies_city"
            name="city_id"
            label="İl"
            placeholder="İl Seçiniz..."
            options={cityOptions || []}
            value={values?.city_id || ''}
            onChange={handleAutoComplete}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <CustomAutoComplete
            id="campaign_pharmacies_district"
            label="İlçe"
            name="district_id"
            placeholder="İlçe Seçiniz..."
            options={districtOptions || []}
            disabled={isDisabled}
            value={values?.district_id || ''}
            onChange={handleAutoComplete}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormInput
            id="campaign_pharmacies"
            name="name"
            placeholder="Eczane Adı"
            label="Eczane Adı"
            onChange={preventNonSpecialDebounceInput}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormBasicSelect
            initialOptText="Tümü"
            id="is_pharmacy_on_duty_id"
            name="is_pharmacy_on_duty"
            label="Nöbet Bilgisi"
            value={values?.is_pharmacy_on_duty}
            options={Constants.pharmacyDutyOptions}
            onChange={handleFilterInputChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormBasicSelect
            initialOptText="Tümü"
            id="is_turp_pharmacy_id"
            name="is_turp_pharmacy"
            label="Turp Eczanesi"
            value={values?.is_turp_pharmacy}
            options={Constants.isTurpPharmacy}
            onChange={handleFilterInputChange}
          />
        </Grid>

        {showDateFilters && (
          <>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <CustomDatePicker
                id="duty_min_date"
                name="min_duty_time"
                label="Başlangıç Tarihi"
                placeholder="Başlangıç tarihi"
                value={values?.min_duty_time || ''}
                maxDate={values?.max_duty_time || new Date('2100-01-01')}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <CustomDatePicker
                id="duty_max_date"
                name="max_duty_time"
                label="Bitiş Tarihi"
                placeholder="Bitiş tarihi"
                value={values?.max_duty_time || ''}
                minDate={values?.min_duty_time || new Date('1900-01-01')}
                onChange={handleChange}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default FilterPharmacies;
